import { Typography } from "@mui/material";
import { Box } from "@mui/system";
import Colors from "../../../../utils/Colors";

const CreateTitle = ({ title, isFirst = false, variant }: { title: string; isFirst?: boolean; variant?: any }) => (
  <Typography fontWeight="bold" pt={isFirst ? 0 : 2} pb={1} color={Colors.ANSWER} variant={variant ? variant : "body1"}>
    {title}
  </Typography>
);

const CreateText = ({ children, variant, fontSize }: any) => (
  <Typography component="span" variant={variant ? variant : "body2"} fontSize={fontSize}>
    {children}
  </Typography>
);

const CreateImage = ({ width, image, responseWidth }: { width?: number | string; image: string; responseWidth?: object }) => (
  <Box component="img" sx={{ float: "left", maxWidth: responseWidth ? responseWidth : `${width}vh`, objectFit: "contain", padding: "0px 10px 0px 0px" }} alt="???" src={image} />
);
const AboutCreateImage = ({ width, image, responseWidth }: { width?: number | string; image: string; responseWidth?: object }) => (
  <Box component="img" sx={{ float: "left", maxWidth: responseWidth ? responseWidth : `${width}vh`, objectFit: "contain" }} alt="???" src={image} />
);

const boldText = (text: string) => <Box sx={{ fontWeight: "bold", display: "inline" }}>{text}</Box>;

export { AboutCreateImage, boldText, CreateImage, CreateText, CreateTitle };
